import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import IntroMM from './IntroMM';
import Barcode from './Barcode';
import Assumptions from './Assumptions';
import Equations from './Equations';
import NumericalS from './NumericalS';
const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};

const MathematicalMpage = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const [backV, setBackV] = useState('transparent');
  const [backVI, setBackVI] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#IMM') {
      setBackI(appColors['ColorF']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
    } else if (key === '#BMM') {
      setBackI('transparent');
      setBackII(appColors['ColorF']);
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
    } else if (key === '#AMM') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorF']);
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
    } else if (key === '#EMM') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorF']);
      setBackV('transparent');
      setBackVI('transparent');
    } else if (key === '#NMM') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV(appColors['ColorF']);
      setBackVI('transparent');
    } else if (key === '#RES') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV(appColors['ColorF']);
      setBackVI('transparent');
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#IMM' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorF'], fontSize: '3vh'}}>Introduction</Text></Content>}/>
          <Link href='#BMM' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorF'], fontSize: '1.6vh'}}>Barcode LFA description</Text></Content>}/>
          <Link href='#AMM' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorF'], fontSize: '3vh'}}>Assumptions</Text></Content>}/>
          <Link href='#EMM' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorF'], fontSize: '3vh'}}>Equations</Text></Content>}/>
          <Link href='#NMM' title={<Content className='ContentAnchor' style={{borderColor: backV}}><Text style={{color: appColors['ColorF'], fontSize: '2vh'}}>Numerical Solution</Text></Content>}/>
          <Link href='#RES' title={<Content className='ContentAnchor' style={{borderColor: backVI}}><Text style={{color: appColors['ColorF'], fontSize: '2vh'}}>Results</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorF'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> M&nbsp;<br/> A&nbsp;<br/> T&nbsp;<br/> H&nbsp;<br/> &nbsp;<br/> M&nbsp;<br/> O&nbsp;<br/> D&nbsp;<br/> E&nbsp;<br/> L&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['Colorx'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='IMM'>
              <IntroMM/>
            </div>
            <div id='BMM'>
              <Barcode/>
            </div>
            <div id='AMM'>
              <Assumptions/>
            </div>
            <div id='EMM'>
              <Equations/>
            </div>
            <div id='NMM'>
              <NumericalS/>
            </div>
            <div id='RES'>

            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default MathematicalMpage;
